<ng-container *ngIf="canContinue">
  <div class="modal-header">
    <h1 id="modal-label-3" class="modal-title">Fais-nous savoir les activités du Forum D'Clic Jeune 2025 qui
      t'intéressent !</h1>
    <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
  </div>

  <!-- <app-cllajinscriptionuser (onNextStep)="goPart2($event)" (onClose)="close($event)" *ngIf="inscriptionService.form.step == 1"></app-cllajinscriptionuser>
  <app-cllajinscriptionlieux (onNextStep)="goPart3($event)" (onPrevStep)="goPart1($event)" *ngIf="inscriptionService.form.step == 2"></app-cllajinscriptionlieux>
  <app-cllajinscriptionsalons (onNextStep)="goPart4($event)" (onPrevStep)="goPart2($event)" *ngIf="inscriptionService.form.step == 3"></app-cllajinscriptionsalons> -->
  <!-- <app-cllajinscriptioncfa (onNextStep)="goPart2($event)" (onClose)="close($event)"
  *ngIf="inscriptionService.form.step == 1"></app-cllajinscriptioncfa> -->
  <app-cllajinscriptionsalons (onNextStep)="goPart2($event)" *ngIf="inscriptionService.form.step == 1">
  </app-cllajinscriptionsalons>
  <!-- <app-cllajinscriptionuser2 (onNextStep)="goPart4($event)" (onPrevStep)="goPart2($event)"
    *ngIf="inscriptionService.form.step == 3"></app-cllajinscriptionuser2> -->
  <!-- <app-cllajinscriptionuser (onNextStep)="goPart3($event)" (onPrevStep)="goPart1($event)" ></app-cllajinscriptionuser> -->
  <!-- <app-cllajinscriptionlieux (onNextStep)="goPart3($event)" (onPrevStep)="goPart1($event)" *ngIf="inscriptionService.form.step == 2"></app-cllajinscriptionlieux> -->

  <div *ngIf="inscriptionService.form.step == 2">
    <div class="modal-body" id="resultfinal" #resultFinal>
      <div class="row">
        <div class="col-lg-12">
          <h3>Félicitations !</h3>
          <p class="highlightMail">
            <strong>Ton Qr Code d'invitation pour le Forum t'a été envoyée par mail.</strong>
            <br />
           Il te faudra le présenter lors de ta venue au Forum.
          </p>

          <ng-container *ngFor="let item of finalForm.lieux.selectedItems">
            <p>
              Nous t'attendons le {{ item.dateDebut | date:"shortDate" }} dès 9h à :<br />
              {{ item.description }}
            </p>
          </ng-container>

          <!-- {{ finalForm.salons.selectedItems | json}} -->
          <ng-container *ngIf="hasInscriptionAndDemande()">
            <p *ngIf="hasNoInscription">
              <strong class="eventtitle sp">Home Dating :</strong><br> Nous traitons ta demande. Surveille tes mails,
              une réponse te sera
              envoyée.
            </p>
          </ng-container>
          <ng-container *ngIf="hasInscriptionOnly()">
            <p *ngIf="hasSP">
              <strong class="eventtitle sp">Home Dating :</strong><br> Pour y participer, tu dois obligatoirement
              déposer une demande de logement sur la plateforme D'Clic Jeune du CLLAJ Martinique !

              <br /><strong>Clique sur le bouton ci-dessous pour continuer:</strong><br />
              <a href="{{cllajUrl}}/annonces/inscription-demande-logement.php" target="_blank" class="btn btn-b">Dépose
                ici ta demande de logement <i class="fas fa-right"></i> </a>
            </p>
          </ng-container>

          <p *ngIf="hasP">
            <strong class="eventtitle p">Les petits salons :</strong><br>
            Nous t'invitons à rejoindre le forum de {{hasP.smallDescription}} <br />
            <ng-container *ngFor="let item of lieux">
              Le {{ item.dateDebut | date: 'EEEE dd MMMM'}} à {{ item.description }}<br />
            </ng-container>
            <br />
            <ng-container *ngIf="selectedActivites?.length">
            <ng-container *ngFor="let activite of selectedActivites;let i = index">
              <strong class="subtitle" *ngIf="activite.smallDescription != selectedActivites[i-1]?.smallDescription">{{activite.smallDescription}}<br/></strong>
              {{activite.title}}<br/>
            </ng-container>
          </ng-container>
          </p>

          <p *ngIf="hasD">
            <strong class="eventtitle d">Traitement de la demande :</strong><br> Consulte les annonces du CLLAJ
            Martinique sur la plateforme
            D'Clic Jeune, puis rends-toi au forum avec <strong class="text-red">ta pièce d'identité.</strong><br />

            <ng-container *ngIf="hasInscriptionAndDemande()">
              <a href="{{cllajUrl}}/annonces/annonces-logement.php" target="_blank" class="btn btn-b">Regarde ici les
                offres de logement <i class="fas fa-right"></i> </a>
            </ng-container>
            <ng-container *ngIf="hasInscriptionOnly()">
              <ng-container *ngIf="!hasSP"><br /><strong>Clique sur le bouton ci-dessous pour continuer:</strong><br />
                <a href="{{cllajUrl}}/annonces/inscription-demande-logement.php" target="_blank"
                  class="btn btn-b">Dépose ici ta demande de logement <i class="fas fa-right"></i></a></ng-container>
            </ng-container>
          </p>


          <br />

          <br />

          <!-- {{ finalForm | json}} -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <p><strong style="font-size: 1.3em;"><i class="fab fa-instagram"></i>&nbsp;<i
            class="fab fa-facebook"></i></strong> Suis toutes les dernières actualités du forum sur les réseaux sociaux
        du CLLAJ Martinique !</p>

      <!-- <button class="btn btn-success btn-b" type="button" (click)="close()">
          Terminer
        </button> -->
    </div>
  </div>
</ng-container>

<ng-container *ngIf="hasQrCode">
  <div class="d-none" id="qrCode">
    <h3>Présente ton QR Code à l'entrée du Forum D’Clic Jeune 2025</h3>

    <div class="qrcode-wrapper">
      <ngx-qrcode-styling [config]="qrCodeConfig"></ngx-qrcode-styling>
    </div>

  </div>
</ng-container>
